import { z } from 'zod';

export const dealerContactSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    role: z.string().optional(),
    email: z.string().email('Invalid email address').optional().or(z.literal('')),
    phone: z.string().optional(),
    notify_agreements: z.boolean().optional(),
    notify_payments: z.boolean().optional(),
});

export type DealerContactFormInput = z.infer<typeof dealerContactSchema>;
